export default __webpack_public_path__ + "static/logo-242b3f2ffa0b95a730ac0760555810bd.png";